import React from 'react';
import { useLocation } from 'react-router-dom';
import {Envelope} from './index';

const EnvelopeWithLocation = () => {
    const location = useLocation();
    return <Envelope location={location} />;
};

export default EnvelopeWithLocation;